import { Button, Box } from '@mui/material';
import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import EmptyMenu from 'components/MenuNew/EmptyMenu';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { MODE, MUI_TO_SX_STYLES } from 'pages/TableOrdering/config';
import TableOrderModal from 'pages/TableOrdering/Tables/TableOrderModal';
import { HeaderContainer, StripedDataGrid } from 'pages/TableOrdering/styles';
import CreateOrEditForm from 'pages/TableOrdering/Employees/CreateOrEditForm';
import { useTableOrderingEmployee } from 'pages/TableOrdering/hooks/useTableOrderingEmployee';
import { useSelector } from 'react-redux';
import EmployeeBusinessesModal from './EmployeeBusinessesModal';

const Employees = () => {
  const { t } = useTranslation();
  const {
    modalState,
    handleCancel,
    formMethods,
    handleSubmit,
    employees,
    columns,
    rowsPerPage,
    setRowsPerPage,
    lastCreatedEmployee,
    handleModalState,
    loading,
    visiblePinCode,
    jobs,
    businessesFields,
    handleAddNewJob,
    handleRemove,
    handleJobChange,
    handleBusinessChange,
    isDisabled,
    employeeState,
    handleCloseBusinessesModal,
    businessAvailableJobs,
    makeDisabled,
  } = useTableOrderingEmployee();

  const { allBusinessList } = useSelector(({ user }) => user);

  return (
    <Box>
      <HeaderContainer>
        <Button
          id="tablesAddTable"
          onClick={() => handleModalState({ open: true, mode: MODE.CREATE })}
          variant="contained"
          color="primary"
          type="button"
          className={`${modalState.open ? 'disabledButton' : ''}`}
          startIcon={<AddOutlinedIcon />}
        >
          {t('Add New Employee')}
        </Button>
      </HeaderContainer>
      <TableOrderModal
        open={modalState.open}
        handleClose={handleCancel}
        title={
          modalState.mode === MODE.CREATE
            ? t('Add New Employee')
            : t('Edit Employee')
        }
        disabled={
          isDisabled ||
          makeDisabled ||
          Object.keys(formMethods.formState.errors).length > 0 ||
          !formMethods.formState.isValid ||
          (modalState.mode === MODE.EDIT && !formMethods.formState.isDirty)
        }
        saveTitle={
          modalState.mode === MODE.CREATE ? t('Add New Employee') : t('Save')
        }
        cancelTitle={'Cancel'}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <CreateOrEditForm
          visiblePinCode={visiblePinCode}
          showPinCode={modalState.showPinCode}
          jobs={jobs}
          businessesFields={businessesFields}
          formMethods={formMethods}
          handleAddNewJob={handleAddNewJob}
          handleRemove={handleRemove}
          handleChange={handleJobChange}
          handleChangeBusinesses={handleBusinessChange}
          businesses={allBusinessList}
          businessAvailableJobs={businessAvailableJobs}
        />
      </TableOrderModal>
      <StripedDataGrid
        sx={MUI_TO_SX_STYLES}
        autoHeight={true}
        hideFooterSelectedRowCount={true}
        isEditable={false}
        hideFooter={true}
        rowsPerPageOptions={[200]}
        getRowClassName={(params) =>
          params?.row?.id === lastCreatedEmployee
            ? 'highlight_last-selected_item'
            : ''
        }
        rows={employees}
        columns={columns}
        pageSize={rowsPerPage}
        onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
        components={{
          LoadingOverlay: Preloader,
          NoRowsOverlay: () => (
            <Box sx={{ mt: '100px' }}>
              <EmptyMenu text={t('There are no employees yet')} />
            </Box>
          ),
        }}
        loading={loading}
      />
      <EmployeeBusinessesModal
        open={employeeState.openBusinessesModal}
        onClose={handleCloseBusinessesModal}
        employee={employeeState.selectedEmployee}
        allBusinessList={allBusinessList}
        jobs={businessAvailableJobs}
      />
    </Box>
  );
};
export default Employees;
